module.exports = __webpack_public_path__ + "static/12-b4187a1d9abe8ba557e3babbb759619a.jpg";